export default __webpack_public_path__ + "static/media/Char3.b82555ff.png";